import { Container } from "components"
import { MinimunScoreModule } from "components/modules/MinimunScore"

export const MinimunScore = () => {

    return (
        <Container className="p-10">
            <MinimunScoreModule />
        </Container>
    )
}